
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `On the Lord's Prayer by Simone Weil | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `On The Lord’s Prayer collects two essays on the power of devotion by the influential mystic philosophers Saint Teresa of Ávila and Simone Weil. Reflecting on the Pater Noster prayer, the authors articulate an urgency of attention that floods all pretenses of our heartbroken present. With a new introduction to Weil’s text by the poet Ariana Reines. 
`);


  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Special/Weil_Back.png', '../../Series-Special/Weil_Side.png', '../../Series-Special/Weil_Front.png']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>On the Lord's Prayer</h1>
            <div className='productAuthor'>Simone Weil</div>
            <div className='productTranslator'>With a text by Ariana Reines</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798990416598'} />
            <div className='productPrice'>$16.99 USD</div>
          </div>

          <div className='productDescription'><em>On The Lord’s Prayer</em> collects two essays on the power of devotion by the influential mystic philosophers Saint Teresa of Ávila and Simone Weil. Reflecting on the <em>Pater Noster</em> prayer, the authors articulate an urgency of attention that floods all pretenses of our heartbroken present. With a new introduction to Weil’s text by the poet Ariana Reines. </div>
          <div className='productDescription'>
            <p>
              Hailed by her posthumous publisher Albert Camus as “the only great spirit of our time,” the French theologian, philosopher and political activist <strong>Simone Weil</strong> (1909-1943) is now widely recognized as a patron saint of modern spirituality. Her writings such as <em>Gravity and Grace</em> advance a metaphysics of ascetic worship rooted in literature, Gnostic Christianity and anarchist politics. She died at age 34 of malnourishment, in solidarity with those living under German occupation.

            </p>
            <p>
              The Spanish Carmelite nun, mystic and religious reformer, <strong>Saint Teresa of Ávila</strong> (1515-1582) sustained profound states of divine union, documented in her writings, teachings and famously, a seraphic transverberation sculpted by Bernini. The first woman to be elevated to doctor of the Church, her works of poetry, autobiography and spiritual counsel form a major corpus of ecstatic meditation.
            </p>

            <p>Born in Salem, MA, United States, <strong>Ariana Reines</strong> is a poet, playwright and translator working in the deep wellsprings of language and the mystic. Her recent writings include <em>Wave of Blood</em> (2025); <em>The Rose</em> (2025); and <em>A Sand Book</em> (2019), winner of the 2020 Kingsley Tufts Prize and longlisted for the National Book Award. </p>
          </div>
          <div className='productMetadata'>
            <div>Special Edition</div>
            <div>Summer 2026</div>
            <div>ISBN  979-8-9904165-9-8</div>
            <div>4.125 x 2.75 inches</div>
            <div>132 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}